export default __webpack_public_path__ + "static/media/stateBackground.48873576.svg";